import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Editor } from '@tinymce/tinymce-react';
import { Box, CircularProgress, TextField } from '@mui/material';

// TinyMCE so the global var exists
import 'tinymce/tinymce';
// DOM model
import 'tinymce/models/dom/model';
// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';
// Editor styles
import 'tinymce/skins/ui/oxide/skin';

// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/help/js/i18n/keynav/en';
import 'tinymce/plugins/image';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/quickbars';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';

// importing plugin resources
import 'tinymce/plugins/emoticons/js/emojis';

// Content styles, including inline UI like fake cursors
import 'tinymce/skins/content/default/content';
import 'tinymce/skins/ui/oxide/content';

import './tinyEditor.scss';

const tinyApiKey = 'glp';

const TinyEditor = ({
  placeholder,
  initialValue,
  onChange,
  onChangeVariation,
  isDisabled,
  prodVariation,
  defaultEditorTag = 'p',
}) => {
  const [editorLoading, setEditorLoading] = useState(!!initialValue);

  return (
    <Box style={{ position: 'relative', minHeight: '56px' }} width="100%">
      {editorLoading && (
        <CircularProgress
          style={{
            position: 'absolute',
            left: 0,
            top: '15px',
          }}
          size="26px"
        />
      )}
      {(isDisabled && !initialValue)
        ? (
          <TextField
            fullWidth
            placeholder={placeholder}
            value=""
            disabled
            variant="outlined"
          />
        ) : (
          <Editor
            disabled={isDisabled}
            apiKey={tinyApiKey}
            init={{
              placeholder,
              height: 500,
              menubar: false,
              statusbar: false,
              plugins: 'lists code image',
              toolbar: 'undo redo | formatselect | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | removeformat | code | image',
              forced_root_block: defaultEditorTag
            }}
            initialValue={initialValue}
            onBlur={prodVariation ? onChangeVariation : onChange}
            onInit={() => setEditorLoading(false)}
          />
        )}
    </Box>
  );
};

TinyEditor.propTypes = {
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  prodVariation: PropTypes.bool,
  onChangeVariation: PropTypes.func,
  defaultEditorTag: PropTypes.string,
};

export default TinyEditor;
